import { substring, isNullOrWhiteSpace, printf, toFail, replace } from "../fable_modules/fable-library.3.7.20/String.js";
import { replace as replace_1 } from "../fable_modules/fable-library.3.7.20/RegExp.js";

export function unEscape(str) {
    return replace(str, "\\n", "\n");
}

export function separateByThousands(input) {
    return replace_1(/(\d)(?=(\d{3})+(?!\d))/gu, input, "$1 ");
}

export function getLanguageCode(countryCode) {
    const matchValue = countryCode.toLocaleUpperCase();
    switch (matchValue) {
        case "SE":
        case "SWE": {
            return "sv";
        }
        case "NO":
        case "NOR": {
            return "nb";
        }
        case "GB":
        case "GBR": {
            return "en";
        }
        case "FI":
        case "FIN": {
            return "fi";
        }
        case "DK":
        case "DNK": {
            return "dk";
        }
        default: {
            return toFail(printf("[getLanguageCode] Cannot get languageCode from %s."))(matchValue);
        }
    }
}

export function capitalize(str) {
    let copyOfStruct;
    if (isNullOrWhiteSpace(str)) {
        return str;
    }
    else {
        const matchValue_1 = str.length | 0;
        switch (matchValue_1) {
            case 0: {
                return str;
            }
            case 1: {
                return str.toLocaleUpperCase();
            }
            default: {
                return ((copyOfStruct = str[0], copyOfStruct)).toLocaleUpperCase() + substring(str, 1);
            }
        }
    }
}

